import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useMemo } from 'react';
import '../WallboardSkillTable/WallboardSkillTable.css';
import { secondsToTime } from '../../utils/util';

export default function WallboardSkillTable(props: any) {

	const { toggleClass } = props;
	const top5SkillsList = useMemo(() => {
		if (props?.top5SkillsList && Array.isArray(props.top5SkillsList)) {
			return props.top5SkillsList;
		}
		return [];
	}, [props.top5SkillsList]);

	return (
		<TableContainer>
			<Table aria-label="simple table" className={`wallboard-table ${toggleClass.tableHeaderBg}`}>
				<TableHead className="wallboard-table-head">
					<TableRow className="wallboard-table-head-row">
						<TableCell className={toggleClass.tableHeadColor}>Skill</TableCell>
						<TableCell align="center" className={toggleClass.tableHeadColor}>
							Queue
						</TableCell>
						<TableCell align="center" className={toggleClass.tableHeadColor}>
							Longest wait time
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{top5SkillsList?.map((row: any) => (
						<TableRow key={row.Skill} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
							<TableCell component="th" scope="row" className={toggleClass.rowCellColor}>
								{row?.Skill || '-'}
							</TableCell>
							<TableCell align="center" className={toggleClass.rowCellColor}>
								{row?.Queue || '-'}
							</TableCell>
							<TableCell align="center" className={toggleClass.rowCellColor}>
								{secondsToTime(row.LongestWaitTime) || '-'}
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
